
import { VaultModel } from '@/models/vault-model.type'
import { Component, Vue } from 'vue-property-decorator'
import { AxiosResponse } from 'axios'

@Component({})
export default class Vaults extends Vue {
  headers = [
    { text: 'Vaults', value: 'name' }
  ]

  vaults = []

  private created () {
    this.axios.get('api/store/vaults').then((response: AxiosResponse) => {
      this.vaults = response.data
    })
  }
}
